import Header from '../../Components/Header'
import DenunciaForm from "../../Components/DenunciaForm"
import DenunciaIntro from '../../Components/DenunciaIntro'

const ContactUsPage = () => {
  return (
    <div>
        <Header/>
        <DenunciaIntro/>
        <DenunciaForm/>
    </div>
  )
}

export default ContactUsPage